/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/hrc/production/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(16);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function toggleAccordion() {
	  var Accordion = function Accordion(el, multiple) {
	    this.el = el || {};
	    this.multiple = multiple || false;
	
	    // Variables privadas
	    var links = this.el.find('.panel-heading');
	    // Evento
	    links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
	  };
	
	  Accordion.prototype.dropdown = function (e) {
	    var $el = e.data.el;
	    var $this = $(this);
	    var $next = $this.next();
	
	    $next.slideToggle();
	    $this.parent().toggleClass('active');
	
	    // TODO
	    // triggerScroll($this.parent());
	
	    if (!e.data.multiple) {
	      $el.find('.panel-collapse').not($next).slideUp().parent().removeClass('active');
	    }
	  };
	
	  var $accordion = new Accordion($('.js-accordion-section'));
	
	  if (!$accordion.length) {
	    return;
	  }
	}
	
	// TODO
	// function triggerScroll(element) {
	//   if (element.hasClass('active')) {
	//     const padding = 20;
	//     const to = element.offset().top - padding;
	
	//     $({ scrollTop: window.scrollY }).animate({ scrollTop: to }, {
	//       duration: 600,
	//       easing: 'swing',
	//       step: function(val) {
	//         window.scrollTo(0, val);
	//       },
	//     });
	//   }
	// }
	
	exports['default'] = { toggleAccordion: toggleAccordion };
	module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function showFilters() {
	  if ($('.filters').length > 0) {
	    (function () {
	      var mobileBreakpoint = 1024;
	      var maxWidthFilterText = 225;
	      var filter = $('.toggle-filter');
	      var filterText = $('.toggle-filter-text');
	      var filterContainer = $('.category-filter > div');
	
	      $('.toggle-filter').on('click', function () {
	        $(this).toggleClass('rotate-arrow');
	        $('.filters').toggleClass('show-filters');
	        if ($('.filters').hasClass('show-filters')) {
	          $('.overlay').addClass('visible');
	        } else {
	          $('.overlay').removeClass('visible');
	        }
	
	        if ($(window).width() < mobileBreakpoint) {
	          $(this).closest('section').toggleClass('primary');
	        }
	      });
	
	      $('.filters a').on('click', function (e) {
	        e.preventDefault();
	        filter.toggleClass('rotate-arrow');
	        $('.filters li').removeClass('selected');
	        $(this).parent().addClass('selected');
	        $(this).closest('.filters').removeClass('show-filters');
	        $('.overlay').removeClass('visible');
	
	        $('.toggle-filter-text').text($(this).data('label'));
	        getLatestArticles($(this).data('category'));
	
	        if (filterText.width() > maxWidthFilterText) {
	          filterText.parent().addClass('new-line');
	          filterContainer.addClass('no-margin');
	        } else {
	          filterText.parent().removeClass('new-line');
	          filterContainer.removeClass('no-margin');
	        }
	      });
	
	      $('.overlay').on('click', function (e) {
	        if (!$(e.target).closest('.category-filter').length > 0) {
	          $('.filters').removeClass('show-filters');
	          $('.toggle-filter').toggleClass('rotate-arrow');
	          $('.overlay').removeClass('visible');
	        }
	      });
	    })();
	  }
	}
	
	function getLatestArticles(category) {
	  $.ajax({
	    type: 'GET',
	    url: jQuery('.category-filters').data('filter'),
	    dataType: 'html',
	    data: {
	      action: 'latest_articles',
	      category: category
	    },
	    success: function success(data) {
	      $('.recent-articles-results').html(data);
	    }
	  });
	}
	
	exports['default'] = { showFilters: showFilters };
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _setCookieJs = __webpack_require__(10);
	
	function cookieMessage() {
	  $('.js-cookie-continue').on('click', function () {
	    $('body').removeClass('cookie-shown');
	    (0, _setCookieJs.setCookie)();
	  });
	}
	exports['default'] = { cookieMessage: cookieMessage };
	module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function initCustomSelect() {
	  var $formSelect = $('.field-size-top-large').dropkick({
	    mobile: true
	  });
	  var selectBox = $('select');
	
	  $('.custom-select').dropkick();
	
	  $('form').submit(function () {
	    if ($(selectBox).hasClass('LV_invalid_field')) {
	      $(selectBox).prev('.dk-select').removeClass('valid').addClass('invalid');
	    }
	  });
	
	  $formSelect.on('change', function () {
	    if ($(this).hasClass('LV_invalid_field')) {
	      $(this).prev('.dk-select').removeClass('valid').addClass('invalid');
	    } else if ($(this).hasClass('LV_valid_field')) {
	      $(this).prev('.dk-select').removeClass('invalid').addClass('valid');
	    }
	  });
	
	  $('input[type="hidden"]').closest('.form-design-field').addClass('hidden');
	}
	
	exports['default'] = { initCustomSelect: initCustomSelect };
	module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function loadItems() {
	  if ($('.home').length > 0 || $('.page').length > 0 || $('.blog').length > 0 || $('.single-post').length > 0) {
	    var animated = $('.fade-in');
	
	    if ($('[data-loadingorder]').length) {
	      setTimeout(function () {
	        loadItemsInOrder($('[data-loadingorder]'));
	      }, 1);
	    }
	
	    $(animated).on('inview', function (event, isInView) {
	      if (isInView) {
	        $(this).addClass('visible');
	      }
	    });
	  }
	}
	
	function loadItemsInOrder(itemsArray, delay) {
	  var delayToUse = delay || 0.4;
	  var sortedItems = itemsArray.sort(function (a, b) {
	    var firstItemOrder = parseInt($(a).attr('data-loadingOrder'), 10);
	    var secondItemOrder = parseInt($(b).attr('data-loadingOrder'), 10);
	    return firstItemOrder - secondItemOrder;
	  });
	  $.each(sortedItems, function (i) {
	    $(sortedItems[i + 1]).removeClass('lazy-loading');
	    $(sortedItems[i + 1]).css('transition-delay', (i + 1) * delayToUse + 's');
	  });
	
	  $(sortedItems[0]).removeClass('lazy-loading');
	  var siblings = $(sortedItems[0]).attr('data-loadingSiblings');
	  if (siblings) {
	    $("[data-loadingSiblings='" + siblings + "']").removeClass('lazy-loading');
	  }
	}
	
	exports['default'] = { loadItems: loadItems };
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function toggleNavigation() {
	  if ($('.menu-bar').length > 0) {
	    (function () {
	      var menuHeight = $(window).height();
	      var menuLinksHeight = $(window).height() - $('.menu-bar').height() - $('.menu').height();
	
	      $('.menu-links').height(menuLinksHeight);
	
	      $('.hamburger-menu').on('click', function () {
	        $('.bar').toggleClass('animate');
	        $('body').toggleClass('disable-scroll');
	        if ($('.mobile .has-submenu').hasClass('show-submenu')) {
	          $('.mobile .has-submenu').removeClass('show-submenu');
	        }
	        if ($('.mobile header').hasClass('show-menu')) {
	          $('.mobile header').removeClass('show-menu');
	          setTimeout(function () {
	            $('.header-wrap').css('height', '80px');
	          }, 500);
	        } else {
	          $('.header-wrap').height(menuHeight);
	          $('.mobile header').addClass('show-menu');
	        }
	      });
	
	      $('.mobile .menu .has-submenu a').on('click', function () {
	        $(this).parent().toggleClass('show-submenu');
	      });
	
	      $('.arrow-back').on('click', function () {
	        $(this).parent().parent().removeClass('show-submenu');
	      });
	    })();
	  }
	}
	
	exports['default'] = { toggleNavigation: toggleNavigation };
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function openSubmenu() {
	  if ($('.has-submenu').length > 0) {
	    $('.mega-menu .has-submenu > a').on('click', function (e) {
	      e.preventDefault();
	      $('body').toggleClass('disable-scroll');
	      if ($(this).parent().hasClass('menu-current-item')) {
	        $('.has-submenu').removeClass('menu-current-item');
	        $(this).parent().removeClass('menu-current-item');
	        $('.overlay').removeClass('visible');
	      } else {
	        $('.has-submenu').removeClass('menu-current-item');
	        $(this).parent().addClass('menu-current-item');
	        $('.overlay').addClass('visible');
	      }
	    });
	
	    $('.overlay').on('click', function (e) {
	      if (!$(e.target).closest('.mega-menu a').length > 0) {
	        $('body').removeClass('disable-scroll');
	        $('.mega-menu .has-submenu').removeClass('menu-current-item');
	        $('.overlay').removeClass('visible');
	      }
	    });
	  }
	}
	
	exports['default'] = { openSubmenu: openSubmenu };
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var table = undefined;
	var options = undefined;
	var data = undefined;
	var filteredCategories = [];
	var searchedTerm = '';
	
	// the comments below are for disable eslint rules
	function initResearchersResults() {
	  if (typeof ResearchersList !== 'undefined' && $('.researchers-results').length > 0) {
	    (function () {
	      // eslint-disable-line no-undef
	      google.charts.load('current', { // eslint-disable-line no-undef
	        'packages': ['table', 'controls'] });
	      // eslint-disable-line quote-props
	      google.charts.setOnLoadCallback(initTable); // eslint-disable-line no-undef
	
	      var typingTimer = undefined;
	      var doneTypingInterval = 1000;
	      var searchInput = $('#search-researchers');
	
	      $('#researchers-results-filtering').on('submit', function (e) {
	        e.preventDefault();
	      });
	
	      searchInput.on('keyup', function () {
	        searchedTerm = $(this).val();
	        displaySearchResultRows();
	        displayNoResults();
	        setColorOnType();
	        addUrlParams(searchedTerm, filteredCategories);
	
	        clearTimeout(typingTimer);
	        typingTimer = setTimeout(doneTyping, doneTypingInterval);
	      });
	
	      searchInput.on('keydown', function () {
	        clearTimeout(typingTimer);
	      });
	
	      $('.filters input[type="checkbox"]').on('click', function () {
	        filteredCategories = [];
	
	        $('.filters input[type="checkbox"]:checked').each(function () {
	          filteredCategories.push($(this).val());
	        });
	
	        addUrlParams(searchedTerm, filteredCategories);
	
	        displaySearchResultRows();
	        $.post($('.filters').data('filter'), { category: filteredCategories, action: 'get_related_articles' }, function (response) {
	          $('.related-articles-result').html(response);
	        }, 'html');
	        displayNoResults();
	      });
	
	      $('.clear-all').on('click', function () {
	        filteredCategories = [];
	
	        $('.filters input[type="checkbox"]').prop('checked', false);
	        displaySearchResultRows();
	      });
	
	      $('#researchers-results-controls select[name="results_per_page"]').on('change', function () {
	        options.pageSize = $(this).val();
	        displaySearchResultRows();
	        scrollPageTop();
	      });
	
	      $('.toggle-categories').on('click', function () {
	        var filterPanel = $(this).closest('.search-area').find('.filters');
	        var searchFilterHeight = 120;
	
	        $(this).toggleClass('toggle-icon');
	        filterPanel.toggleClass('show-filters');
	        if ($(this).hasClass('toggle-icon')) {
	          $('.open-filter').removeClass('ico-filter').addClass('ico-close');
	          $('html, body').animate({
	            scrollTop: $('.researchers-results').offset().top - searchFilterHeight
	          }, 1000);
	        } else {
	          $('.open-filter').removeClass('ico-close').addClass('ico-filter');
	        }
	      });
	    })();
	  }
	}
	
	function initTable() {
	  data = new google.visualization.DataTable(); // eslint-disable-line no-undef
	
	  if (ResearchersList.cols.length > 0) {
	    // eslint-disable-line no-undef
	    $.each(ResearchersList.cols, function (key, col) {
	      // eslint-disable-line no-undef
	      data.addColumn('string', col);
	    });
	  }
	
	  data.addRows(ResearchersList.rows); // eslint-disable-line no-undef
	  data.sort({ column: 0 });
	
	  table = new google.visualization.Table(document.getElementById('researchers-results')); // eslint-disable-line no-undef
	  options = {
	    width: '100%',
	    height: '100%',
	    page: 'enable',
	    pageSize: $('#researchers-results-controls select[name="results_per_page"]').val(),
	    pagingSymbols: {
	      prev: 'Previous',
	      next: 'Next'
	    },
	    pagingButtonsConfiguration: 'auto',
	    pagingButtons: '6',
	    sort: 'enable',
	    sortColumn: 0,
	    sortAscending: true,
	    allowHtml: true
	  };
	
	  table.draw(data, options);
	  google.visualization.events.addListener(table, 'page', pageEventHandler); // eslint-disable-line no-undef
	  google.visualization.events.addListener(table, 'page', showFirstPage); // eslint-disable-line no-undef
	  resultRowsFullWidth();
	
	  loadFromHash();
	}
	
	function resultRowsFullWidth() {
	  $('.google-visualization-table-tr-head').append('<div class="background-wrap"></div>');
	  $('tr td:first-child').append('<div class="background-wrap"></div>');
	  $('.background-wrap').append('<div class="background"></div>');
	  $('tr').each(function () {
	    var rowHeight = $(this).height();
	    var bgEl = $(this).find('.background');
	
	    bgEl.height(rowHeight);
	  });
	  $('.google-visualization-table-page-numbers a:nth-child(5)').after('<span class="dots">...</span>');
	}
	
	function getSearchResultRows(data, filters) {
	  // eslint-disable-line no-shadow
	  var searchableFreeTextColumns = [0, 2];
	  var filteredRows = [];
	
	  for (var i in searchableFreeTextColumns) {
	    var column = searchableFreeTextColumns[i];
	
	    var filteredResults = data.getFilteredRows([{
	      column: column,
	      test: function test(columnValue) {
	        if (filters.freeTextSearchTerm.length > 1) {
	          if (columnValue.indexOf('alt="') > -1) {
	            return columnValue.split('alt="').pop().split('"').shift().toLowerCase().indexOf(filters.freeTextSearchTerm.toLowerCase()) !== -1;
	          } else {
	            // eslint-disable-line no-else-return
	            return columnValue.toLowerCase().indexOf(filters.freeTextSearchTerm.toLowerCase()) !== -1;
	          }
	        } else {
	          // eslint-disable-line no-else-return
	          return true;
	        }
	      }
	    }, {
	      column: 1,
	      test: function test(category) {
	        if (filters.categoriesTerms.length > 0) {
	          return $.inArray(category.replace(/[&]/g, 'and').replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g, '').toLowerCase(), filters.categoriesTerms) !== -1; // eslint-disable-line no-useless-escape
	        } else {
	            // eslint-disable-line no-else-return
	            return true;
	          }
	      }
	    }]);
	
	    filteredRows = $.merge(filteredRows, filteredResults);
	  }
	
	  return $.unique(filteredRows);
	}
	
	function displaySearchResultRows() {
	  var view = new google.visualization.DataView(data); // eslint-disable-line no-undef
	  if (!(searchedTerm.length < 2 && filteredCategories.length === 0)) {
	    view.setRows(getSearchResultRows(data, {
	      freeTextSearchTerm: searchedTerm,
	      categoriesTerms: filteredCategories
	    }));
	  }
	
	  table.draw(view, options);
	  resultRowsFullWidth();
	}
	
	function displayNoResults() {
	  var resultsField = $('.researchers-results tbody');
	  var noResultsContainer = $('.no-results');
	  var searchTerm = $('#searched-term');
	
	  if (resultsField.children().length === 0) {
	    $(noResultsContainer).addClass('show');
	    $('.google-visualization-table-div-page').addClass('hide');
	    $(searchTerm).text($('#search-researchers').val());
	  } else {
	    $(noResultsContainer).removeClass('show');
	    $('.google-visualization-table-div-page').removeClass('hide');
	  }
	}
	
	function pageEventHandler() {
	  scrollPageTop();
	}
	
	function scrollPageTop() {
	  var fromTop = 350;
	  var searchFieldHeight = 70;
	
	  if ($(window).scrollTop() > fromTop) {
	    $('html, body').animate({
	      scrollTop: $('.researchers-results').offset().top + searchFieldHeight
	    }, 1000);
	  }
	  resultRowsFullWidth();
	}
	
	function showFirstPage() {
	  var $firstPage = $('.google-visualization-table-page-numbers a:first-child');
	  var $lastPage = $('.google-visualization-table-page-numbers a:last-child');
	
	  $firstPage.text(1);
	  $firstPage.after('<span class="dots">...</span>');
	  $firstPage.on('click', function () {
	    displaySearchResultRows();
	  });
	  $lastPage.on('click', function () {
	    $lastPage.after('');
	  });
	}
	
	function setColorOnType() {
	  var $search = $('.js-search-list');
	  var $searchInput = $search.find('.search-input');
	
	  if ($search.length > 0) {
	    var inputValue = $searchInput.val();
	    if (inputValue) {
	      $search.addClass('is-typing');
	    } else {
	      $search.removeClass('is-typing');
	    }
	  }
	}
	
	function doneTyping() {
	  var resultsField = $('.researchers-results tbody');
	  var resultsOffsetTop = 420;
	
	  if (!(searchedTerm.length < 2) && !(resultsField.children().length === 0)) {
	    $('html, body').animate({
	      scrollTop: resultsOffsetTop
	    }, 1000);
	  }
	}
	
	function addUrlParams(terms, categories) {
	  var searchTerms = '';
	  if (terms !== '') {
	    searchTerms = 'freeText=' + terms;
	  }
	
	  categories.filter(function (v) {
	    return v !== '';
	  });
	
	  if (!$.isEmptyObject(categories)) {
	    if (searchTerms !== '') {
	      searchTerms += '&';
	      searchTerms += 'categories=' + categories;
	    } else {
	      searchTerms = 'categories=' + categories;
	    }
	  }
	
	  window.location.hash = encodeURIComponent(searchTerms);
	}
	
	function loadFromHash() {
	  var currentHash = decodeURIComponent(window.location.hash).slice(1);
	  var array = currentHash.split('&');
	  var values;
	  var formData = {};
	  var i;
	
	  for (i = 0; i < array.length; i += 1) {
	    values = array[i].split('=');
	    formData[values[0]] = values[1];
	  }
	
	  if (formData.hasOwnProperty('freeText')) {
	    // eslint-disable-line no-prototype-builtins
	    searchedTerm = formData.freeText;
	    $('.search-input').val(searchedTerm);
	  }
	
	  if (formData.hasOwnProperty('categories')) {
	    // eslint-disable-line no-prototype-builtins
	    filteredCategories = formData.categories.split(',');
	    $.each(filteredCategories, function (k, v) {
	      $('#' + v).attr('checked', 'checked');
	    });
	  }
	
	  displaySearchResultRows();
	}
	
	exports['default'] = { initResearchersResults: initResearchersResults };
	module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function triggerSearch() {
	  var $search = $('.js-search-article');
	  var $searchInput = $search.find('.search-input');
	  var searchTitle = $('.blog-page .module-title');
	  var pagination = $('.pagination');
	
	  if ($search.length > 0) {
	    $searchInput.on('keyup', function () {
	      var inputValue = $searchInput.val();
	      if (inputValue) {
	        $search.addClass('is-typing');
	      } else {
	        $search.removeClass('is-typing');
	      }
	    });
	  }
	
	  if ($('.blog').length > 0) {
	    var resultString = $('.blog-page .module-title h4').html();
	    var noResult = '0';
	    var checkResult = resultString.match(noResult);
	
	    if (checkResult) {
	      $(searchTitle).addClass('hide');
	    } else {
	      $(searchTitle).removeClass('hide');
	    }
	  }
	
	  if ($('.pagination .column').children().length === 0) {
	    $(pagination).addClass('hide');
	  } else {
	    $(pagination).removeClass('hide');
	  }
	}
	
	exports['default'] = { triggerSearch: triggerSearch };
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function setCookie() {
	  var cookieName = 'clarivate_cookie_policy';
	  var cookieValue = 1;
	  var d = new Date();
	  var path = 'path=/';
	  d.setMonth(d.getMonth() + 1);
	  document.cookie = cookieName + '=' + cookieValue + ';expires=' + d.toGMTString() + ';' + path;
	}
	
	exports['default'] = { setCookie: setCookie };
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function initStickyNavMobile() {
	  var didScroll = undefined;
	  var lastScrollTop = 0;
	  var navbarHeight = $('.header-wrap').outerHeight();
	
	  $(window).scroll(function () {
	    didScroll = true;
	  });
	
	  setInterval(function () {
	    if (didScroll && $(window).width() < 1025) {
	      hasScrolled();
	      didScroll = false;
	    }
	  }, 250);
	
	  function hasScrolled() {
	    var st = $(window).scrollTop();
	
	    if (st > lastScrollTop && st > navbarHeight - 70) {
	      $('.header-wrap').addClass('header-up');
	    } else if (st + $(window).height() < $(document).height()) {
	      $('.header-wrap').removeClass('header-up');
	      setTimeout(function () {
	        $('.page-wrap').removeClass('hide');
	      }, 300);
	    }
	
	    lastScrollTop = st;
	  }
	}
	
	exports['default'] = { initStickyNavMobile: initStickyNavMobile };
	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function initStickyNav() {
	  var didScroll = undefined;
	  var lastScrollTop = 0;
	  var navbarHeight = $('.mega-menu').outerHeight();
	
	  $(window).scroll(function () {
	    didScroll = true;
	  });
	
	  if (!($('.page-wrap').height() < $(window).height())) {
	    setInterval(function () {
	      if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	      }
	    }, 250);
	  }
	
	  function hasScrolled() {
	    var st = $(window).scrollTop();
	
	    if (st > lastScrollTop && st > navbarHeight - 70) {
	      $('.page-wrap').removeClass('up').addClass('hide');
	      $('.top-menu').removeClass('top-menu-scrollup').addClass('top-menu-up');
	      $('.mega-menu').removeClass('mega-menu-scrollup').addClass('mega-menu-up');
	      $('.overlay').removeClass('scrollup').addClass('fixed-top');
	    } else if (st + $(window).height() < $(document).height()) {
	      $('.page-wrap').removeClass('hide').addClass('up');
	      $('.top-menu').removeClass('top-menu-up').addClass('top-menu-scrollup');
	      $('.mega-menu').removeClass('mega-menu-up').addClass('mega-menu-scrollup');
	      $('.overlay').removeClass('fixed-top').addClass('scrollup');
	      if (st === 0) {
	        $('.mega-menu').removeClass('mega-menu-scrollup');
	        $('.top-menu').removeClass('top-menu-scrollup');
	        $('.page-wrap').removeClass('up hide');
	        $('.overlay').removeClass('scrollup fixed-top');
	      }
	    }
	
	    lastScrollTop = st;
	  }
	}
	
	exports['default'] = { initStickyNav: initStickyNav };
	module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function initStickySideNav() {
	  var resizeWidth = $(window).width();
	  var mobileBreakpoint = 1025;
	
	  if (resizeWidth < mobileBreakpoint) {
	    $('.sidebar-fixed').trigger('sticky_kit:detach');
	  } else {
	    makeSticky();
	  }
	}
	
	function makeSticky() {
	  $('.sidebar-fixed').stick_in_parent({
	    parent: '.article-wrapper',
	    spacer: false,
	    recalc_every: 1,
	    sticky_class: 'is-stuck'
	  });
	}
	
	exports['default'] = { initStickySideNav: initStickySideNav };
	module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// Article Overview category dropdown
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function toggleTagDropdown() {
	  var $toggleTrigger = $('.js-popular-tags-trigger');
	
	  if ($toggleTrigger.length > 0) {
	    $toggleTrigger.on('click', function () {
	      var $submenu = $(this).prev().find('.popular-tags-more');
	      var $text = $(this).find('span');
	      var $icon = $(this).find('i');
	
	      $submenu.toggleClass('open');
	
	      if ($submenu.hasClass('open')) {
	        $submenu.slideDown();
	        $icon.removeClass();
	        $icon.addClass('ico-minus');
	        $text.text('View less categories');
	      } else {
	        $submenu.slideUp();
	        $icon.removeClass();
	        $icon.addClass('ico-plus');
	        $text.text('View more categories');
	      }
	    });
	  }
	}
	
	exports['default'] = { toggleTagDropdown: toggleTagDropdown };
	module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function trackClickGa() {
	  var _gaq = _gaq || []; // eslint-disable-line no-underscore-dangle
	  _gaq.push(['_setAccount', 'UA-112955599-1']);
	  _gaq.push(['_trackPageview']);
	
	  $('.athlon-link a').on('click', function () {
	    _gaq.push(['_trackEvent', 'Click', 'Open weareathlon.com']);
	  });
	  $('.harrington-starr-link a').on('click', function () {
	    _gaq.push(['_trackEvent', 'Click', 'Open harringtonstarr.com']);
	  });
	  $('.js-subscribe').on('click', function () {
	    _gaq.push(['_trackEvent', 'Click', 'Subscribe']);
	  });
	  $('.js-get-in-touch').on('click', function () {
	    _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
	  });
	  $('.logo-module a').on('click', function () {
	    if ($(this).attr('href').indexOf('harringtonstarr') > -1) {
	      _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
	    } else if ($(this).attr('href').indexOf('athlon') > -1) {
	      _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
	    }
	  });
	}
	
	exports['default'] = { trackClickGa: trackClickGa };
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _scssInitScss = __webpack_require__(17);
	
	var _scssInitScss2 = _interopRequireDefault(_scssInitScss);
	
	// eslint-disable-line no-unused-vars
	
	// UI scripts
	
	var _customNavigationJs = __webpack_require__(7);
	
	var _customMobileNavigationJs = __webpack_require__(6);
	
	var _customCustomSelectJs = __webpack_require__(4);
	
	var _customCookieMessageJs = __webpack_require__(3);
	
	var _customStickyNavJs = __webpack_require__(12);
	
	var _customStickyNavMobileJs = __webpack_require__(11);
	
	var _customLazyLoadingJs = __webpack_require__(5);
	
	var _customCategoryFiltersJs = __webpack_require__(2);
	
	var _customStickySideNavJs = __webpack_require__(13);
	
	var _customAccordionJs = __webpack_require__(1);
	
	var _customTagDropdownJs = __webpack_require__(14);
	
	var _customSearchJs = __webpack_require__(9);
	
	var _customResearchersResultsJs = __webpack_require__(8);
	
	var _customTriggerClickGaJs = __webpack_require__(15);
	
	$(function () {
	  (0, _customNavigationJs.openSubmenu)();
	  (0, _customMobileNavigationJs.toggleNavigation)();
	  (0, _customCustomSelectJs.initCustomSelect)();
	  (0, _customCookieMessageJs.cookieMessage)();
	  (0, _customStickyNavJs.initStickyNav)();
	  (0, _customStickyNavMobileJs.initStickyNavMobile)();
	  (0, _customLazyLoadingJs.loadItems)();
	  videoPopupInit();
	  imagePopupInit();
	  (0, _customCategoryFiltersJs.showFilters)();
	  (0, _customStickySideNavJs.initStickySideNav)();
	  (0, _customAccordionJs.toggleAccordion)();
	  (0, _customTagDropdownJs.toggleTagDropdown)();
	  (0, _customSearchJs.triggerSearch)();
	  (0, _customResearchersResultsJs.initResearchersResults)();
	  (0, _customTriggerClickGaJs.trackClickGa)();
	
	  $('a[target="_blank"]').attr('rel', 'noopener noreferrer');
	
	  $('#filter-nav').tinyNav({
	    active: 'active'
	  });
	
	  if ($('.category-results .column').length < 5) {
	    $('.category-results').addClass('show-all');
	  }
	
	  $(window).on('resize', function () {
	    (0, _customStickySideNavJs.initStickySideNav)();
	  });
	
	  $('.hero-area').each(function () {
	    if ($('.feedback-box', this).length > 0) {
	      $(this).addClass('send-feedback');
	      $(this).prev('section').addClass('breadcrumb-top');
	    }
	  });
	
	  $('.author-info .show-detail-info').on('click', function (event) {
	    event.preventDefault();
	    $(this).closest('.author-info').addClass('js-open-info');
	  });
	  $('.author-info .ico-close').on('click', function (event) {
	    event.preventDefault();
	    $(this).closest('.author-info').toggleClass('js-open-info');
	  });
	  $('.author-info .full-cover-back').on('click', function (event) {
	    event.preventDefault();
	    $(this).closest('.author-info').removeClass('js-open-info');
	  });
	
	  // go to anchor link
	  $('a[href^="#"]').on('click', function (e) {
	    var hash = this.hash;
	
	    if (hash !== '') {
	      e.preventDefault();
	      $('html, body').animate({
	        scrollTop: $(hash).offset().top - 70
	      }, 1200, function () {});
	    }
	  });
	
	  function videoPopupInit() {
	    $('.popup-video').magnificPopup({
	      type: 'iframe',
	      preloader: true
	    });
	
	    $('.open-popup-link').magnificPopup({
	      type: 'inline',
	      showCloseBtn: false,
	      midClick: true });
	
	    // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	    $('.popup-close').on('click', function () {
	      $.magnificPopup.close();
	    });
	  }
	
	  function imagePopupInit() {
	    $('.open-image').magnificPopup({
	      type: 'image',
	      closeBtnInside: true,
	      closeOnContentClick: false
	    });
	  }
	});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js